import TransferTemplatesPage from "components/pages/TransferTemplatesPage";

/**
 * @name CaptureTransferTemplatesMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureTransferTemplatesMain(props) {
    return <TransferTemplatesPage/>;
}